// Image URL helper utilities
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Get the full URL for an image, handling both absolute and relative URLs
 * @param {string} url - The image URL (can be relative or absolute)
 * @returns {string} - The full image URL
 */
export const getImageUrl = (url) => {
  if (!url) return '';
  // If already an absolute URL, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // For relative URLs, prepend the backend URL
  return `${BACKEND_URL}${url}`;
};

/**
 * Get the primary image URL from a product
 * @param {object} product - The product object
 * @returns {string} - The primary image URL
 */
export const getProductImageUrl = (product) => {
  if (!product) return '';
  
  // Check for images array first (new format)
  if (product.images && product.images.length > 0) {
    const primaryImage = product.images.find(img => img.is_primary) || product.images[0];
    const url = typeof primaryImage === 'string' ? primaryImage : primaryImage?.url;
    return getImageUrl(url);
  }
  
  // Fallback to imageUrl field (legacy format)
  if (product.imageUrl) {
    return getImageUrl(product.imageUrl);
  }
  
  return '';
};

/**
 * Get all image URLs from a product
 * @param {object} product - The product object
 * @returns {array} - Array of full image URLs
 */
export const getProductImages = (product) => {
  if (!product) return [];
  
  if (product.images && product.images.length > 0) {
    return product.images.map(img => {
      const url = typeof img === 'string' ? img : img?.url;
      return getImageUrl(url);
    });
  }
  
  if (product.imageUrl) {
    return [getImageUrl(product.imageUrl)];
  }
  
  return [];
};

export default { getImageUrl, getProductImageUrl, getProductImages };
